/*
 * The company the wizard has just created in this tab, so that its detail page, where the wizard
 * leads, says so once. Kept in memory only: never in the address, the history or the browser's
 * storage, so a reload or a later visit shows the detail as usual.
 */

let created: string | null = null

export function rememberCreatedCompany(organizationId: string): void {
  created = organizationId
}

/** Whether the detail of `organizationId` is the one the wizard has just led to. */
export function isJustCreated(organizationId: string): boolean {
  return created === organizationId
}

/** Once the detail has said so. */
export function forgetCreatedCompany(): void {
  created = null
}
